import {
  SLAReport,
  SLAReportGroupInput,
  SLAReportSort,
  SLAResponseTimeSectionSort,
  StandardDateRange,
} from "@/lib/queries/reports.ts";
import {ServiceGroup, ServiceTag} from "@/lib/types/checks.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {
  checksField,
  deleteGroupsField,
  groupInEditChecksField,
  groupInEditNameField,
  newGroupsField,
} from "@/pages/reports/sla/SLAReportForm.utils.tsx";

export enum SLAReportFormTabs {
  GLOBAL = "global",
  REPORTING_GROUPS = "reportingGroups",
}

export enum MultiServiceTarget {
  Report = "report",
  GroupInEdit = "group_in_edit",
}

export interface SLAReportFormValues {
  id?: number;
  name: string;
  default_date_range: StandardDateRange;
  [checksField]: number[];
  services_tags: number[];
  show_uptime_section: boolean;
  show_uptime_sla: boolean;
  filter_with_downtime: boolean;
  filter_uptime_sla_violations: boolean;
  uptime_section_sort: SLAReportSort;
  show_response_time_section: boolean;
  show_response_time_sla: boolean;
  filter_slowest: boolean;
  filter_response_time_sla_violations: boolean;
  response_time_section_sort: SLAResponseTimeSectionSort;
  [newGroupsField]: SLAReportGroupInput[];
  [deleteGroupsField]: number[];
  logo?: string | FileList | null;
  [groupInEditNameField]?: string;
  [groupInEditChecksField]?: number[];
}

export interface SLAReportFormProps {
  title: string;
  formId: string;
  onSubmit: (data: SLAReportFormValues) => void;
  onCancel: () => void;
  monitoringServiceTypes: ServiceGroup[];
  serverErrors: ServerErrors;
  tags: ServiceTag[];
  slaReport?: SLAReport;
  slaReportGlobalLogoUrl: string;
}
